export default {
  pageSize: 12,
  searchResultsApi: "/fashion/customercaresearch/v1/",
};
